module.exports = __webpack_public_path__ + "static/img/jungong1.03534d6b.png";